jQuery(function ($) {
    var html = $('html');
    var lists = $('.site-header .main .nav .menu > ul > li > ul');
    var items = lists.parent('li');

    var hidden = '-hidden';
    var visible = '-visible';
    var visibility = [hidden, visible].join(' ');

    lists.each(function (i, domList) {
        var list = $(domList);
        var item = list.parent();
        var link = $('<a href="#" class="toggle"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M7,10L12,15L17,10H7Z" /></svg></a>');

        link.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            item.toggleClass(visibility);
            items.not(item).addClass(hidden).removeClass(visible);
        });

        item.addClass(hidden).removeClass(visible);
        list.before(link);
    });

    html.on('click', function (e) {
        items.addClass(hidden).removeClass(visible);
    });
});
